/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: cad93d606839
 */

import * as z from "zod";
import { collectExtraKeys as collectExtraKeys$ } from "../lib/schemas.js";

/**
 * Contextual metadata grouped by kind. Custom user context appears under the 'custom' key. Other context kinds may also appear as additional keys.
 */
export type ContextFullResponse = {
  custom?: { [k: string]: string } | undefined;
  AdditionalProperties?: { [k: string]: { [k: string]: string } };
};

export const ContextFullResponse$zodSchema: z.ZodType<ContextFullResponse> =
  collectExtraKeys$(
    z.object({
      custom: z.record(z.string(), z.string()).optional().describe(
        "User-defined contextual metadata as key-value pairs.",
      ),
    }).describe(
      "Contextual metadata grouped by kind. Custom user context appears under the 'custom' key. Other context kinds may also appear as additional keys.",
    ).catchall(z.record(z.string(), z.string())),
    "AdditionalProperties",
    true,
  );

export const ContextFullResponse$zodSchemaOutbound: z.ZodType<any> = z.object({
  AdditionalProperties: z.record(z.string(), z.record(z.string(), z.string()))
    .optional(),
  custom: z.record(z.string(), z.string()).optional(),
}).describe(
  "Contextual metadata grouped by kind. Custom user context appears under the 'custom' key. Other context kinds may also appear as additional keys.",
).transform((v) => {
  const { AdditionalProperties, ...rest } = v;
  return {
    ...rest,
    ...AdditionalProperties,
  };
});
